import styled, { css } from 'styled-components';

import { COLOR_PINK_BRAND, COLOR_WHITE } from 'styles/variables/colors';

export const Container = styled.div`
  display: flex;
  align-items: center;
`;

export const Label = styled.p`
  padding: 10px;
  margin: 0;
  font-weight: 700;
  color: ${COLOR_WHITE};
`;

export const Indicator = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: ${COLOR_PINK_BRAND};
  transition: 0.3s;
`;

export const Button = styled.button`
  background: ${COLOR_WHITE};
  border: none;
  padding: 5px;
  width: 50px;
  border-radius: 30px;
  display: flex;
  cursor: pointer;

  &:focus {
    outline: 0;
  }

  ${(props) =>
    props.activeSide === 'left' &&
    css`
      & ${Indicator} {
        transform: translateX(0);
      }
    `}

  ${(props) =>
    props.activeSide === 'right' &&
    css`
      & ${Indicator} {
        transform: translateX(20px);
      }
    `}
`;
